import React from 'react';

class PillGroup extends React.Component {
  isSelected = (option) => {
    const { value, multiple } = this.props;
    if (multiple) {
      return Array.isArray(value) && value.includes(option);
    }
    return value === option;
  };

  handleClick = (option) => {
    const { value, multiple, onChange } = this.props;
    if (!onChange) return;
    if (multiple) {
      const safe = Array.isArray(value) ? value : [];
      const next = safe.includes(option)
        ? safe.filter((v) => v !== option)
        : [...safe, option];
      onChange(next);
    } else {
      onChange(option);
    }
  };

  render() {
    const { options, columns, fieldId, error } = this.props;
    const hasError = !!error;
    const colClass = columns === 2
      ? 'grid grid-cols-1 sm:grid-cols-2 gap-3'
      : columns === 3
        ? 'grid grid-cols-2 sm:grid-cols-3 gap-3'
        : columns === 4
          ? 'grid grid-cols-2 sm:grid-cols-4 gap-3'
          : 'flex flex-wrap gap-3';

    return (
      <div data-field-id={fieldId || undefined}>
        <div
          className={colClass}
          style={
            hasError
              ? {
                  padding: '6px',
                  margin: '-6px',
                  borderRadius: '14px',
                  boxShadow: '0 0 0 1px #DC2626',
                }
              : undefined
          }
        >
          {options.map((opt) => {
            const optionValue = typeof opt === 'string' ? opt : opt.value;
            const optionLabel = typeof opt === 'string' ? opt : opt.label;
            const selected = this.isSelected(optionValue);
            return (
              <button
                key={optionValue}
                type="button"
                onClick={() => this.handleClick(optionValue)}
                className="rounded-xl border-2 px-4 py-3 text-sm sm:text-base font-medium transition-colors text-center"
                style={{
                  backgroundColor: selected ? '#EFEAFE' : '#FFFFFF',
                  borderColor: selected ? '#7C5CFC' : '#D1D5DB',
                  color: selected ? '#5B3FE0' : '#1F2937',
                }}
              >
                {optionLabel}
              </button>
            );
          })}
        </div>
        {hasError ? (
          <p className="mt-2 text-xs font-medium text-[#DC2626]">{error}</p>
        ) : null}
      </div>
    );
  }
}

export default PillGroup;
